import { DocumentAccess } from "../documents/types";

import type { AttachmentCreate } from "./types";

/**
 * The stored object's name: the last segment of its storage key.
 *
 * Since H282 the backend picks the key (POST /v6/storage/upload-url returns a free
 * `image-2.jpg` when `image.jpg` is taken), so this — not the picked file's name — is
 * what the attachment row's `filename` holds and what its delete matches on.
 */
export function storedName(key: string): string {
  return key.slice(key.lastIndexOf("/") + 1);
}

/**
 * The attachment row for a file just stored under `storedKey`: `filename` is the
 * stored name, `title` the name the user picked (what they recognise).
 * Mobile's receipts (public/mobile/js/mobile-expenses.js attachmentBody) use the same
 * pair.
 */
export function attachmentForUpload(args: {
  displayName: string;
  storedKey: string;
  source: string;
  id: number;
  access?: number;
}): AttachmentCreate {
  return {
    title: args.displayName,
    filename: storedName(args.storedKey),
    source_id: args.id,
    source_type: args.source,
    access: args.access || DocumentAccess.Internal,
  };
}
